import React, { Component } from 'react';

import PropTypes from 'prop-types';
import StreamDotPlotChart from '../../../common/components/charts/stream-dot-plot-chart';
import { connect } from 'react-redux';
import { dmarcEffectivenessVisSelector } from '../../selectors/dmarc-effectiveness-selectors';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';

export class DmarcEffectivenessVisContainer extends Component{
    constructor( props ){
        super( props );

        this.state = {
            height: 250,
            margin: {
                bottom: 48,
                left: 0,
                right: 8,
                top: 8,
            },
            width: 800
        };
    }

    render(){
        const { isLoading, selectedInterval, dmarcEffectivenessVisData } = this.props;
        const { height, margin, width } = this.state;

        const options = { height, margin, width };
        const dotPlotOptions = {
            key: 'blockRate',
        };

        const streamOptions = {
            keys: ['total'],
        };

        return (
            <StreamDotPlotChart
                data={dmarcEffectivenessVisData}
                xKey="date"
                dotPlotOptions={dotPlotOptions}
                streamOptions={streamOptions}
                interval={selectedInterval}
                isLoading={isLoading}
                options={options}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        dmarcEffectivenessVisData: dmarcEffectivenessVisSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
    };
};

DmarcEffectivenessVisContainer.propTypes = {
    dmarcEffectivenessVisData: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedInterval: PropTypes.string,
};

export default connect( mapStateToProps )( DmarcEffectivenessVisContainer );
